import { CONTENT_MAX_WIDTH } from "../constants";
import { ProductName } from "./ProductName";

export const FooterContent = () => {
  return (
    <div
      style={{
        position: 'relative',
        color: '#5D6C70',
        fontSize: 14,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        maxWidth: CONTENT_MAX_WIDTH,
        margin: 'auto',
      }}
    >
      <div style={{ paddingRight: 15 }}>
        <ProductName />
      </div>
      <div>
        <ul
          style={{ listStyle: 'none', padding: 0, margin: 0, lineHeight: 1.5 }}
        >
          <li>
            <a href="/privacy-policy" target="_blank">Privacy policy</a>
          </li>
          {/* <li>
            <a href="/terms-of-service">Terms of service</a>
          </li> */}
          <li>
            <a href="mailto:oksmartwallet@gmail.com">Request a card</a>
          </li>
          <li>
            <a href="mailto:oksmartwallet@gmail.com">Contact us</a>
          </li>

          {/* <li><a href="/about">About</a></li> */}
        </ul>
        <div>
          <p>
            SmartWallet is a free tool to help you get the best rewards for your
            credit cards. We're not affiliated with any credit card companies.
          </p>
          <p>
            Our data is independently gathered and reviewed by our team, but we
            may not always get it right. If you find an error, please{' '}
            <a href="mailto:oksmartwallet@gmail.com">let us know</a>.
          </p>
        </div>
      </div>
    </div>
  );
}